import { render } from "./EOISubmittion.vue?vue&type=template&id=c4a45c62"
import script from "./EOISubmittion.vue?vue&type=script&lang=js"
export * from "./EOISubmittion.vue?vue&type=script&lang=js"
script.render = render

export default script